import React from "react";
import style from "./index.module.scss";
import { curSessionIdAtom } from "../../store";

import ContactsList from "./Components/ContactsList";
import ChatContainer from "./Components/ChatContainter";
import { useAtomValue } from "jotai";
import { CustomEmpty } from "../../polyfills";

export function LayoutPC() {
    //会话列表
    const sessionId = useAtomValue(curSessionIdAtom);

    return (
        <div className={style.root}>
            <div className={style.left}>
                <ContactsList />
            </div>

            <div className={style.right}>
                {sessionId && (
                    <ChatContainer key={sessionId} sessionId={sessionId} />
                )}

                {!sessionId && (
                    <CustomEmpty
                        description="暂无聊天"
                        style={{ padding: "200px 0" }}
                    />
                )}
            </div>
        </div>
    );
}
